import { Card } from "antd";
import styled from "styled-components";

export const StyledCard = styled(Card)`
  .ant-collapse-header {
    padding: 0;
    align-items: center !important;
  }
  .ant-collapse-header .ant-typography {
    margin: 0;
  }

  .ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
    padding: 14px 0 0 0 !important;
  }

  .ant-collapse-item {
    margin: 0 !important;
    border-bottom: none !important;
  }

  .ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 0 !important;
    margin: 0 !important;
  }

  .ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {
    right: 0;
  }
`;
